<div class="mini-wrapper">
  <div class="sub-wrapper">
    <h1 class="landing mb-4 text-center">{{ 'sessionExpired.title' | transloco }}</h1>
    <div class="mt-3 mb-4">
      <div>{{ 'sessionExpired.description' | transloco }}</div>
    </div>

    <div class="mb-4">
      {{ 'sessionExpired.paragrapgh' | transloco }}
      <a class="link" target="_blank" href="https://public.epd-portal.ru/assets/static_files/json/links/Terms%20and%20conditions%20of%20use%20of%20the%20GIS%20EPD%20Portal.pdf"> {{ 'sessionExpired.terms' | transloco }}</a>
      {{ 'sessionExpired.user' | transloco }}
    </div>

    <app-contacts-info></app-contacts-info>

    <div class="row g-3 mt-2">
      <div class="col-12 col-sm-6">
        <button class="primary xl w-100" mat-button (click)="oauthService.redirectToSignIn()">{{ 'sessionExpired.retry' | transloco }}</button>
      </div>
      <div class="col-12 col-sm-6">
        <button class="primary xl w-100" disableRipple mat-button [routerLink]="['/logout']">{{ 'sessionExpired.gomain' | transloco }}</button>
      </div>
    </div>
  </div>
</div>
